import { api } from '@/shared/api/httpClient'

// Cômodos são usados por mais de uma feature (devices, mcp/consent), por isso
// vivem em shared/ — features não importam umas das outras.
export interface RoomRef {
  id: number
  name: string
}

export interface Room extends RoomRef {
  device_count: number
}

export const roomsApi = {
  list: () => api.get<Room[]>('/rooms/'),
  create: (name: string) => api.post<Room>('/rooms/', { name }),
  rename: (id: number, name: string) => api.patch<Room>(`/rooms/${id}/`, { name }),
  remove: (id: number) => api.delete<void>(`/rooms/${id}/`),
}
